// Tiny shared flag — not React state. withAuthentication.js is a HOC
// instantiated separately on many unrelated page components (not siblings
// or descendants of Support.js in any prop-drillable way), but it needs to
// know "is the Zendesk conversation currently open" to decide whether the
// native launcher/chrome should stay visible for the user to dismiss it.
// Kept updated by a single subscription set up once in
// useSupportController.js (see its "messenger:on" effect); read
// synchronously here wherever needed.
let open = false;

export const setMessengerOpen = (value) => {
  open = value;
};

export const isMessengerOpen = () => open;
